// frontend/packs/application.js

import 'init';

import ApplicationController from 'components/global/application/application-controller';
import SiteFooterController from 'components/global/site-footer/site-footer-controller';

window.EezyStimulusApplication.register('application', ApplicationController);
window.EezyStimulusApplication.register('site-footer', SiteFooterController);
